import { useQuery } from '@tanstack/react-query';
import Chart from 'components/charts/Echart';
import { Spinner } from 'components/shared/loader/Spinner';
import GNERadio from 'components/shared/radio/GNERadio';
import {
  areas,
  BOB_BENEFIT_TYPE,
  NO_DATA_AVAILABLE,
  NUMBER_ZERO,
  QLIK_DATATYPE,
  QUERY_KEY,
} from 'constants/constants';
import { useState } from 'react';
import { Fade } from 'react-awesome-reveal';
import { usePromiseTracker } from 'react-promise-tracker';
import { useSelector } from 'react-redux';
import { getBobMixData } from 'store/customer/customer-view-actions';
import classes from './McoBanner.module.scss';

const McoPieChart = () => {
  const [benefitType, setBenefitType] = useState(BOB_BENEFIT_TYPE.MEDICAL);
  const selectedCustomer = useSelector(
    (state) => state?.CustomerView?.selectedCustomer
  );
  const { roleId } = useSelector((state) => state.Auth.userClaimObject);
  const { promiseInProgress } = usePromiseTracker({
    area: areas.bannerBoB,
    delay: 0,
  });

  const { data } = useQuery({
    queryKey: [QUERY_KEY.BOBMixData, selectedCustomer?.value, benefitType],
    queryFn: async () => {
      const params = {
        mdmId: selectedCustomer?.value,
        entityType: selectedCustomer?.flag,
        benefitType: benefitType,
        roleId,
      };
      const response = await getBobMixData(params);
      return response;
    },
  });

  const handleBenefitTypeChange = (value) => {
    setBenefitType(value);
  };

  const radioBtnSize = {
    padding: 0,
    '& .MuiSvgIcon-root': {
      fontSize: '1rem',
    },
  };

  const pieChartStyle = {
    height: '100%',
    width: '100%',
    overflow: 'hidden',
  };

  const legend = {
    orient: 'vertical',
    align: 'auto',
    bottom: 18,
    height: '45%',
    width: '100%',
    icon: 'circle',
    itemWidth: 9,
    left: 10,
    textStyle: {
      color: '#ffffff',
      fontSize: '9px',
    },
    formatter: function (name) {
      return `${name}`;
    },
  };

  return (
    <>
      <div className='d-flex justify-content-center title__bold title__small title__capitalize mb-1 pt-1'>
        BoB Mix
      </div>
      <div className={`${classes['bob-chart']} d-flex flex-column h-100`}>
        <div className='d-flex align-items-center justify-content-center z-2 mt-2 mb-2'>
          <GNERadio
            checked={benefitType === BOB_BENEFIT_TYPE.MEDICAL}
            name='benefitTypes'
            label={BOB_BENEFIT_TYPE.MEDICAL}
            value={BOB_BENEFIT_TYPE.MEDICAL}
            onChange={() => handleBenefitTypeChange(BOB_BENEFIT_TYPE.MEDICAL)}
            wrapperCss={'white-radio-btn'}
            sx={radioBtnSize}
          />
          <GNERadio
            checked={benefitType === BOB_BENEFIT_TYPE.PHARMACY}
            name='benefitTypes'
            label={BOB_BENEFIT_TYPE.PHARMACY}
            value={BOB_BENEFIT_TYPE.PHARMACY}
            onChange={() => handleBenefitTypeChange(BOB_BENEFIT_TYPE.PHARMACY)}
            wrapperCss={'white-radio-btn'}
            sx={radioBtnSize}
          />
        </div>
        {promiseInProgress ? (
          <div className='d-flex align-items-center justify-content-center h-100'>
            <Fade>
              <Spinner area={areas.bannerBoB} />
            </Fade>
          </div>
        ) : data?.length > NUMBER_ZERO ? (
          <>
            <div className={classes['bob-chart-container']}>
              <Chart
                chartData={data}
                chartType={QLIK_DATATYPE.payerPie}
                radius='52%'
                center={['50%', '27%']}
                legend={legend}
                isMultiChart={true}
                style={pieChartStyle}
              />
            </div>
            <div
              className={`title title__x-small ms-3 ${classes['bob-chart-text']}`}>
              <i>% of Lives Covered</i>
            </div>
          </>
        ) : (
          <div
            className={`d-flex align-items-center flex-column justify-content-center h-100${!promiseInProgress ? ` ${classes['bob-chart-no-data']}` : ''}`}>
            {!promiseInProgress ? (
              NO_DATA_AVAILABLE
            ) : (
              <Fade>
                <Spinner area={areas.bannerBoB} />
              </Fade>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default McoPieChart;
